var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { useTheme } from "@chakra-ui/react";
import { keyframes } from "@chakra-ui/system";
import { wax } from "../../core";
import { CompassColor } from "../../core/constants";
function Circle(props) {
    return (React.createElement(wax.div, Object.assign({}, props, { borderRadius: "full", borderStyle: "solid", position: "absolute" })));
}
const spin = keyframes({
    "0%": {
        transform: "rotate(0deg)",
    },
    "50%": {
        transform: "rotate(-180deg)",
    },
    "100%": {
        transform: "rotate(-360deg)",
    },
});
/**
 * Loaders provide a visual cue that an action is processing awaiting a course of change or a result. In a shape of a spinning noom logo.
 */
export function Loader(_a) {
    var _b, _c, _d;
    var { size = "md", speed = "2.5s", color = CompassColor.offWhite } = _a, rest = __rest(_a, ["size", "speed", "color"]);
    const theme = useTheme();
    const themeStyle = (_d = (_c = (_b = theme.components.CompassLoader) === null || _b === void 0 ? void 0 : _b.sizes) === null || _c === void 0 ? void 0 : _c[size]) !== null && _d !== void 0 ? _d : {};
    const bigSize = `78%`;
    const smallSize = `32%`;
    const borderWidthBig = `calc(${themeStyle.h} * 0.12)`;
    const borderWidthSmall = `calc(${themeStyle.h} * 0.09)`;
    return (React.createElement(wax.div, Object.assign({ borderRadius: "50%", position: "relative" }, themeStyle, rest, { animation: `${spin} ${speed} cubic-bezier(0.5, 0, 0.5, 1) infinite` }),
        React.createElement(Circle, { bgColor: "transparent", borderColor: color, borderWidth: borderWidthBig, h: bigSize, w: bigSize, bottom: 0, left: 0 }),
        React.createElement(Circle, { bgColor: "transparent", borderColor: color, borderWidth: borderWidthSmall, h: smallSize, w: smallSize, top: 0, right: 0 })));
}
Loader.displayName = "CompassLoader";
export default Loader;
//# sourceMappingURL=CompassLoader.js.map